import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  title: "Couldn't load your Accounts",
  description:
    'An error occurred when loading your Account details. Please try again and {contactZellerSupport} if the problem persists.',
  contactZellerSupport: 'contact Zeller Support',
})
